import React from "react";
import { Trash2 } from "lucide-react";

const DeleteConfirmation = ({
  isOpen,
  onClose,
  onConfirm,
  itemName = "item",
  title = "Confirm Deletion",
}) => {
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
      role="dialog"
      aria-labelledby="delete-confirmation-title"
      aria-describedby="delete-confirmation-desc"
    >
      <div className="bg-white rounded-lg shadow-xl p-6 w-96">
        <div className="flex items-center mb-4">
          <Trash2 className="text-red-500 mr-3" size={24} />
          <h2
            id="delete-confirmation-title"
            className="text-xl font-bold text-gray-800"
          >
            {title}
          </h2>
        </div>
        <p id="delete-confirmation-desc" className="text-gray-600 mb-6">
          Are you sure you want to delete this {itemName}? This action cannot be
          undone.
        </p>
        <div className="flex justify-end space-x-3">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-200 text-gray-700 rounded hover:bg-gray-300 transition"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600 transition"
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmation;
